import React from 'react';
import './index.less';

const Footer = () => {
  return <div className='footer'>版权所有PA</div>;
};

export default Footer;
